var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.8125C16.6006 2.8125 13.2776 3.82053 10.4511 5.7091C7.6247 7.5977 5.4217 10.282 4.12083 13.4226C2.81995 16.5632 2.47958 20.0191 3.14276 23.3531C3.80594 26.6872 5.4429 29.7497 7.8466 32.1534C10.2503 34.5571 13.3128 36.1941 16.6469 36.8572C19.9809 37.5204 23.4368 37.1801 26.5774 35.8792C29.718 34.5783 32.4023 32.3753 34.2909 29.5489C36.1795 26.7224 37.1875 23.3994 37.1875 20C37.1875 15.4416 35.3767 11.0699 32.1534 7.8466C28.9301 4.62332 24.5584 2.8125 20 2.8125Z",
    stroke: "#A6A6A7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 14.7547C14.5312 14.7547 14.6133 13.0457 16.4424 11.574C17.5273 10.7 18.8281 10.447 20 10.4295C21.0674 10.4158 22.0205 10.5925 22.5908 10.864C23.5674 11.3289 25.4688 12.4636 25.4688 14.8767C25.4688 17.4158 23.8086 18.5691 21.917 19.8377C20.0254 21.1062 19.5117 22.4832 19.5117 23.906",
    stroke: "#A6A6A7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8672 28.9844C20.8672 29.7869 20.2166 30.4375 19.4141 30.4375C18.6115 30.4375 17.9609 29.7869 17.9609 28.9844C17.9609 28.1818 18.6115 27.5312 19.4141 27.5312C20.2166 27.5312 20.8672 28.1818 20.8672 28.9844Z",
    fill: "#A6A6A7",
    stroke: "#A6A6A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelpIcon);
export default __webpack_public_path__ + "static/media/ic-help-icon.cca1fcf2ba7d76c37613cc0da6cca9a2.svg";
export { ForwardRef as ReactComponent };